/* ============================================================
   BURL — add-to-cart popup (desktop card / mobile bottom sheet)
   ============================================================ */
(function () {
  'use strict';
  var fmt = window.__moneyFormat || '${{amount}}';
  function money(c) {
    if (c == null) return '';
    var a = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, a)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a);
  }
  window.burlMoney = money;

  var pop = document.getElementById('cartPop');
  var scrim = document.getElementById('cartPopScrim');
  if (!pop) return;
  var t;

  function hide() { pop.classList.remove('show'); if (scrim) scrim.classList.remove('show'); }

  window.showCartPopup = function (item) {
    if (item) {
      var img = document.getElementById('cartPopImg');
      if (img) { if (item.image) { img.src = item.image; img.style.display = ''; } else { img.style.display = 'none'; } }
      var nm = document.getElementById('cartPopName'); if (nm) nm.textContent = item.product_title || item.title || '';
      var vt = (item.variant_title && item.variant_title.indexOf('Default') < 0) ? item.variant_title : '';
      if (item.properties && item.properties.Surface) vt = (vt ? vt + ' \u00b7 ' : '') + 'Surface: ' + item.properties.Surface;
      var vEl = document.getElementById('cartPopVar'); if (vEl) vEl.textContent = vt;
      var pr = document.getElementById('cartPopPrice'); if (pr) pr.textContent = money(item.price);
    }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var sub = document.getElementById('cartPopSub'); if (sub) sub.textContent = money(c.items_subtotal_price);
        document.querySelectorAll('#cartCount, .nav__cart-count').forEach(function (cc) { cc.textContent = c.item_count; });
      }).catch(function () {});
    pop.classList.add('show'); if (scrim) scrim.classList.add('show');
    clearTimeout(t); t = setTimeout(hide, 5000);
  };

  var cl = document.getElementById('cartPopClose'); if (cl) cl.addEventListener('click', hide);
  if (scrim) scrim.addEventListener('click', hide);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
})();
